export default __webpack_public_path__ + "static/media/brunei.c6ace6ff.png";